/* tslint:disable */
/* eslint-disable */
/**
 * pinnacle-backend API spec
 * Backend Service for Pinnacle Underwriting | [swagger.json](pinnacle/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PaginationDto } from './PaginationDto';
import {
    PaginationDtoFromJSON,
    PaginationDtoFromJSONTyped,
    PaginationDtoToJSON,
    PaginationDtoToJSONTyped,
} from './PaginationDto';
import type { ContractResponseDto } from './ContractResponseDto';
import {
    ContractResponseDtoFromJSON,
    ContractResponseDtoFromJSONTyped,
    ContractResponseDtoToJSON,
    ContractResponseDtoToJSONTyped,
} from './ContractResponseDto';

/**
 * 
 * @export
 * @interface ContractPaginationResponseDto
 */
export interface ContractPaginationResponseDto {
    /**
     * 
     * @type {PaginationDto}
     * @memberof ContractPaginationResponseDto
     */
    pagination: PaginationDto;
    /**
     * 
     * @type {Array<ContractResponseDto>}
     * @memberof ContractPaginationResponseDto
     */
    items: Array<ContractResponseDto>;
}

/**
 * Check if a given object implements the ContractPaginationResponseDto interface.
 */
export function instanceOfContractPaginationResponseDto(value: object): value is ContractPaginationResponseDto {
    if (!('pagination' in value) || value['pagination'] === undefined) return false;
    if (!('items' in value) || value['items'] === undefined) return false;
    return true;
}

export function ContractPaginationResponseDtoFromJSON(json: any): ContractPaginationResponseDto {
    return ContractPaginationResponseDtoFromJSONTyped(json, false);
}

export function ContractPaginationResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ContractPaginationResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'pagination': PaginationDtoFromJSON(json['pagination']),
        'items': ((json['items'] as Array<any>).map(ContractResponseDtoFromJSON)),
    };
}

export function ContractPaginationResponseDtoToJSON(json: any): ContractPaginationResponseDto {
    return ContractPaginationResponseDtoToJSONTyped(json, false);
}

export function ContractPaginationResponseDtoToJSONTyped(value?: ContractPaginationResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'pagination': PaginationDtoToJSON(value['pagination']),
        'items': ((value['items'] as Array<any>).map(ContractResponseDtoToJSON)),
    };
}

